import { render } from "./MemberTierDetail.vue?vue&type=template&id=42b88050"
import script from "./MemberTierDetail.vue?vue&type=script&lang=js"
export * from "./MemberTierDetail.vue?vue&type=script&lang=js"

import "./MemberTierDetail.vue?vue&type=style&index=0&id=42b88050&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__